import Link from "next/link";
import { useRouter } from "next/router";
import { CaraCerdasList } from "src/data/literasi-keuangan/CaraCerdasContent";

const CaraCerdasSidebar = () => {
  const router = useRouter();
  const activeSlug = router.query.slug || "rencana_tujuan";
  return (
    <div className="CaraCerdas-sidebar">
      <h1 className="CaraCerdas-sidebar-heading">Cara Cerdas</h1>
      {CaraCerdasList.map((item, index) => (
        <Link href={item.link} key={index}>
          <a>
            <div
              className={`CaraCerdas-sidebar-menu ${
                activeSlug.includes(item.slug) ? "active" : ""
              }`}
            >
              <img
                src={item.icon}
                alt={item.title}
                className="CaraCerdas-sidebar-icon"
              />
              <div className="CaraCerdas-sidebar-title">{item.title}</div>
            </div>
          </a>
        </Link>
      ))}
      <style jsx>{`
        .CaraCerdas-sidebar {
          width: 308px;
          display: flex;
          flex-direction: column;
          margin-top: 10px;
        }
        .CaraCerdas-sidebar-heading {
          font-size: 28px;
          margin-bottom: 10px;
        }
        .CaraCerdas-sidebar-menu {
          display: flex;
          height: 64px;
          align-items: center;
          border-radius: 8px;
          margin-top: 6px;
        }
        .CaraCerdas-sidebar-menu.active {
          background: var(--color-red);
          color: white;
        }
        .CaraCerdas-sidebar-menu.active .CaraCerdas-sidebar-icon {
          filter: brightness(0) invert(1);
        }
        .CaraCerdas-sidebar-menu:hover {
          background: var(--color-red);
          color: white;
        }
        .CaraCerdas-sidebar-menu:hover .CaraCerdas-sidebar-icon {
          filter: brightness(0) invert(1);
        }
        .CaraCerdas-sidebar-icon {
          width: 32px;
          height: 32px;
          margin: 16px;
          transition: filter 0.3s ease;
        }
        .CaraCerdas-sidebar-title {
          font-size: 16px;
          font-weight: 500;
        }
        @media only screen and (max-width: 700px) {
          .CaraCerdas-sidebar {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};
export default CaraCerdasSidebar;
